export enum ERoles {
  admin = 1,
  cashier = 2,
  activator = 3,
  communicationsAgency = 4,
  branchManager = 5,
  lealCustomerService = 6,
}
